import React from "react";
import mobBanner from "../assets/pink-mob.jpg";
import desktopBanner from "../assets/pink-web.jpg";
import SpiritualSpring from "../assets/USA-Ashram-Square.jpg";

function SpringPage() {
  return (
    <div className="bg-[#fedcdb]">
      <>
        <img
          src={desktopBanner}
          alt={"desktop"}
          class="hidden md:block w-full h-auto object-cover"
        />
        <img
          src={mobBanner}
          alt={"mobile"}
          className="block md:hidden w-full h-auto object-cover"
        />
      </>
      <section className="bg-gradient-to-r from-[#f3e1c9] to-[#f3e1c9] py-16 text-center">
        <div className="mt-8 flex flex-col md:flex-row justify-center items-center gap-6">
          <div className="bg-white shadow-lg rounded-full w-48 h-48 flex flex-col justify-center items-center p-4 text-center">
            <p className="text-sm font-semibold text-black">
              Shibir with Pujya Gurudevshri
            </p>
            <p className="text-sm font-medium text-[#e64b77]">
              18 April – 20 April
            </p>
            <button
              className="mt-2 bg-[#e64b77] text-white text-xs font-bold px-6 py-1 rounded-lg shadow-md hover:bg-[rgb(254,220,219)] hover:text-[#e64b77]"
              onClick={() =>
                window.open("https://www.srmd.org/usa/april-shibir", "_blank")
              }
            >
              VIEW
            </button>
          </div>
          <div className="bg-white shadow-lg rounded-full w-52 h-52 flex flex-col justify-center items-center p-4 text-center">
            <p className="text-md font-semibold text-black">
              Registration for Weekdays
            </p>
            <p className="text-sm font-medium text-[#e64b77]">
              21 April – 24 April
            </p>
            <button
              className="mt-2 bg-[#e64b77] text-white text-xs font-bold px-6 py-1 rounded-lg shadow-md hover:bg-[rgb(254,220,219)] hover:text-[#e64b77]"
              onClick={() =>
                window.open(
                  "https://register.srmd.org/events/AW2501",
                  "_blank"
                )
              }
            >
              VIEW
            </button>
          </div>
          <div className="bg-white shadow-lg rounded-full w-48 h-48 flex flex-col justify-center items-center p-4 text-center">
            <p className="text-sm font-semibold text-black">
              Yoga Retreat with Pujya Gurudevshri
            </p>
            <p className="text-sm font-medium text-[#e64b77]">
              25 April – 27 April
            </p>
            <button
              className="mt-2 bg-[#e64b77] text-white text-xs font-bold px-6 py-1 rounded-lg shadow-md hover:bg-[rgb(254,220,219)] hover:text-[#e64b77]"
              onClick={() =>
                window.open("https://www.srmd.org/usa/yoga-retreat", "_blank")
              }
            >
              VIEW
            </button>
          </div>
        </div>
      </section>
      <section className="bg-gradient-to-r from-[#f5eadc] via-[#f5eadc] to-[#f5eadc] py-10 px-6 md:px-20 text-white">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
          {/* Left Content */}
          <div className="md:w-1/2  flex sm:hidden justify-center">
            <div className="relative w-72 h-72 md:w-96 md:h-96">
              <img
                src="https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/08/VPM-Satsang1.jpg?x63391"
                alt="Event Highlights"
                className="w-full h-full rounded-full object-cover shadow-lg"
              />
            </div>
          </div>
          <div className="md:w-1/2 text-center md:text-left" id="Shibir">
            <h2 className="text-3xl md:text-4xl font-extrabold text-rose-900">
              Shibir with Pujya Gurudevshri
            </h2>
            <p className="text-lg md:text-xl font-semibold mt-3 text-rose-900">
              Fri, 18 April – Sun, 20 April
            </p>

            {/* Buttons */}
            <div className="mt-6 flex flex-wrap justify-center md:justify-start gap-4">
              <button
                className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition"
                onClick={() =>
                  window.open(
                    "https://www.srmd.org/usa/april-shibir/",
                    "_blank"
                  )
                }
              >
                Register Now
              </button>
              <button
                className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition hidden"
                onClick={() =>
                  window.open(
                    "https://www.srmd.org/usa/april-shibir#Schedule",
                    "_blank"
                  )
                }
              >
                Schedule
              </button>
              <button
                className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition hidden"
                onClick={() =>
                  window.open(
                    "https://www.srmd.org/usa/april-shibir#Accommodations",
                    "_blank"
                  )
                }
              >
                Accommodations
              </button>
              <button
                className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition hidden"
                onClick={() =>
                  window.open(
                    "https://www.srmd.org/usa/april-shibir#Sponsorships",
                    "_blank"
                  )
                }
              >
                Sponsorships
              </button>
            </div>
          </div>
          <div className="md:w-1/2  hidden sm:flex   justify-center">
            <div className="relative w-72 h-72 md:w-96 md:h-96">
              <img
                src="https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/08/VPM-Satsang1.jpg?x63391"
                alt="Event Highlights"
                className="w-full h-full rounded-full object-cover shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="bg-gradient-to-r from-[#f5eadc] via-[#f5eadc] to-[#f5eadc] text-white py-10 px-6 md:px-20 flex flex-col md:flex-row items-center justify-center">
        {/* Image Section */}
        <div className="w-full md:w-1/2 flex justify-center mb-6 md:mb-0">
          <div className="w-72 h-72 md:w-96 md:h-96 rounded-full overflow-hidden">
            <img
              src={SpiritualSpring}
              alt="Event Highlight"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Content Section */}
        <div className="w-full md:w-1/2 text-center md:text-left" id="nonShibirDays">
          <h2 className="text-3xl md:text-4xl font-extrabold text-rose-900">
            Registration for Weekdays
          </h2>
          <p className="text-m font-semibold mt-3 text-black">(Please note that Pujya Gurudevshri may not be at the US Ashram during the weekdays)</p>
          <p className="text-lg md:text-xl font-semibold mt-3 text-rose-900">
            Mon, 21 April – Thu, 24 April
          </p>
          {/* <p className="text-md text-yellow-200 font-semibold">
          Inauguration by Shri Mohan Bhagwat
        </p> */}

          <div className="mt-6 flex flex-wrap justify-center md:justify-start gap-4">
            <button className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition" onClick={() =>
              window.open(
                "https://register.srmd.org/events/AW2501",
                "_blank"
              )
            }>
              Register Now
            </button>
          </div>
        </div>
      </section>
      <section className="bg-gradient-to-r from-[#f5eadc] via-[#f5eadc] to-[#f5eadc] py-10 px-6 md:px-20 text-white">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
          {/* Left Content */}
          <div className="md:w-1/2  flex sm:hidden justify-center">
            <div className="relative w-72 h-72 md:w-96 md:h-96">
              <img
                src="https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/09/Yoga.jpg?x63391"
                alt="Event Highlights"
                className="w-full h-full rounded-full object-cover shadow-lg"
              />
            </div>
          </div>
          <div className="md:w-1/2 text-center md:text-left" id="yogaRetreat">
            <h2 className="text-3xl md:text-4xl font-extrabold text-rose-900">
              Yoga Retreat with Pujya Gurudevshri
            </h2>
            <p className=" mt-4 text-lg font-semibold ">
              <span className="text-rose-900">Fri, 25 April – Sun, 27 April </span>
            </p>

            {/* Buttons */}
            <div className="mt-6 flex flex-wrap justify-center md:justify-start gap-4">
              <button
                className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition"
                onClick={() =>
                  window.open(
                    "https://www.srmd.org/usa/yoga-retreat/",
                    "_blank"
                  )
                }
              >
                Register Now
              </button>
              <button
                className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition hidden"
                onClick={() =>
                  window.open(
                    "https://www.srmd.org/usa/yoga-retreat#Schedule",
                    "_blank"
                  )
                }
              >
                Schedule
              </button>
              <button
                className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition hidden"
                onClick={() =>
                  window.open(
                    "https://www.srmd.org/usa/yoga-retreat#Accommodations",
                    "_blank"
                  )
                }
              >
                Accommodations
              </button>
              <button
                className="bg-white text-[#e64b77] font-semibold px-4 py-2 rounded-full shadow-md hover:bg-gray-200 transition hidden"
                onClick={() =>
                  window.open(
                    "https://www.srmd.org/usa/yoga-retreat#Sponsorships",
                    "_blank"
                  )
                }
              >
                Sponsorships
              </button>
            </div>
          </div>
          <div className="md:w-1/2  hidden sm:flex   justify-center">
            <div className="relative w-72 h-72 md:w-96 md:h-96">
              <img
                src="https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/09/Yoga.jpg?x63391"
                alt="Event Highlights"
                className="w-full h-full rounded-full object-cover shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SpringPage;
